var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerEnv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86874 6.98593V9.87968H7.73437C9.17968 9.87968 10.3562 8.70312 10.3562 7.25781V4.36406H7.49062C6.04531 4.36406 4.86874 5.54062 4.86874 6.98593ZM9.41874 7.25625C9.41874 8.18593 8.66249 8.94062 7.73437 8.94062H6.19218C6.22187 8.89062 6.25468 8.83906 6.29062 8.78593C6.70156 8.17812 7.30312 7.7375 8.07812 7.47656L7.77812 6.58906C6.83906 6.90625 6.21249 7.41406 5.80781 7.88125V6.98593C5.80781 6.05625 6.56406 5.30156 7.49218 5.30156H9.42031V7.25625H9.41874Z",
    fill: "#194DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67656 12.0656H13.2375C13.8391 12.0656 14.3281 11.5766 14.3281 10.975V3.24375C14.3281 2.64218 13.8391 2.15312 13.2375 2.15312H2.67656C2.075 2.15312 1.58594 2.64218 1.58594 3.24375V10.9734C1.58594 11.5766 2.075 12.0656 2.67656 12.0656ZM2.67969 3.24687H13.2344V10.9719H2.67969V3.24687ZM13.9359 12.8016H2.18281C1.88125 12.8016 1.63594 13.0469 1.63594 13.3484C1.63594 13.65 1.88125 13.8953 2.18281 13.8953H13.9359C14.2375 13.8953 14.4828 13.65 14.4828 13.3484C14.4828 13.0469 14.2391 12.8016 13.9359 12.8016Z",
    fill: "#194DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerEnv);
export default __webpack_public_path__ + "static/media/computer-env.3e7e09615124aadc8bbab00137a97479.svg";
export { ForwardRef as ReactComponent };